export const domain = "https://tools.ellngr.com/"